import React from 'react';

import { Paper } from '@mui/material';
import { Document, Page } from 'react-pdf';

import { createSimpleRange } from '@clearverify/utils';

import { FullscreenLoader } from 'src/components/common';
import type { SxProp } from 'src/types/mui';
import { composeSx } from 'src/utils/styles';

type PdfRendererProps = {
  src: string | undefined;
  containerStyles?: SxProp;
} & Pick<React.ComponentProps<typeof Page>, 'renderMode'>;

export const PdfRenderer: React.FC<PdfRendererProps> = ({
  src,
  containerStyles = {},
  renderMode = 'canvas',
}) => {
  const [pages, setPages] = React.useState<number | null>(null);

  const renderPages = () => {
    if (pages) {
      return createSimpleRange(pages).map(pageIndex => (
        <Page key={pageIndex} renderMode={renderMode} pageNumber={pageIndex + 1} />
      ));
    }
    return <Page renderMode={renderMode} pageNumber={1} />;
  };

  return (
    <Paper variant="outlined" sx={composeSx(defaultContainerStyles, containerStyles)}>
      <Document
        onLoadSuccess={({ numPages }) => setPages(numPages)}
        file={src}
        loading={renderLoader}
        renderMode={renderMode}
      >
        {renderPages()}
      </Document>
    </Paper>
  );
};

const defaultContainerStyles: SxProp = {
  maxHeight: '725px',
  overflow: 'scroll',
  borderRadius: 2,
};

const renderLoader = () => {
  return <FullscreenLoader sx={{ height: 500 }} />;
};
